import { MenuProvider } from './menu'
import { SellerProvider } from './seller'
import OrdersWebSocketProvider from './ordersWebSocket'

const AppProvider = ({ children }) => {
  return (
    <MenuProvider>
      <SellerProvider>
        <OrdersWebSocketProvider>{children}</OrdersWebSocketProvider>
      </SellerProvider>
    </MenuProvider>
  )
}

export default AppProvider
